import { render, staticRenderFns } from "./ServiceProvidersCommunities.vue?vue&type=template&id=d48ae578&"
import script from "./ServiceProvidersCommunities.vue?vue&type=script&lang=ts&"
export * from "./ServiceProvidersCommunities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports